import { observable, configure, action, computed } from 'mobx';
import StoreModel from './storeModel';

configure({ enforceActions: 'always' });

class RodregStore extends StoreModel {
    constructor() {
        super('rodreg', {
            namePlural: 'rodregs',
            sort: '-purchase_date',
            api: {
                search: {
                    url: '/api/rodregs/',
                    params: {},
                },
                load: {
                    url: '/api/rodregs/',
                    params: {},
                },
                save: {
                    url: '/api/rodregs/',
                    params: {},
                },
                delete: {
                    url: '/api/rodregs/',
                    params: {},
                },
            },
            queryFilter: {},
        });
    }

    @observable rodreg = {};

    @observable rodregs = [];

    @observable deleted = {};

    @action
    markDeleted(id) {
        this.deleted[id] = true;
    }
}

const store = new RodregStore();
export default store;



// WEBPACK FOOTER //
// ./stores/rodreg.js